import { createContext, Dispatch, SetStateAction } from "react";

export const ErrorContext = createContext<{
  error: any;
  setError: Dispatch<SetStateAction<any>>;
}>(undefined as any);
